export enum OperationRequestType {
  PurgeAssetRequest = "PurgeAssetRequest",
  DeleteAssetRequest = "DeleteAssetRequest",
  MoveAsset = "MoveAsset",
  BypassAssetRejection = "BypassAssetRejection",
  ProxyError = "ProxyError",
  CopyAsset = "CopyAsset",
  SwitchClassToRaw = "SwitchClassToRaw",
  SwitchClassToMezz = "SwitchClassToMezz",
}
